import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({ features: ['business_intelligence.upsell'] })
export default class HotelBiUpsellRoute extends Route {}
